import { render, staticRenderFns } from "./DatatableSelect.vue?vue&type=template&id=c5267f5e&"
import script from "./DatatableSelect.vue?vue&type=script&lang=js&"
export * from "./DatatableSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports